import { render, staticRenderFns } from "./lt-followup-modal.vue?vue&type=template&id=4432c8f2&scoped=true&"
import script from "./lt-followup-modal.vue?vue&type=script&lang=js&"
export * from "./lt-followup-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4432c8f2",
  null
  
)

export default component.exports